import type { TaskRunState } from '@developerz/domain';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { StatusPill, type StatusTone } from './StatusPill';

// Where a run is (#5918), as one pill. The server decides `run.state`
// (`readTaskRunStatus`); this only paints it, for the task drawer and the admin
// run page alike. Only `live` pulses: a released, errored or long-silent run is
// over, and `!finished` used to call all three live.
const RUN_STATE_PILL: Readonly<Record<TaskRunState, { tone: StatusTone; label: string }>> = {
  live: { tone: 'live', label: 'fleet.run_state.live' },
  finished: { tone: 'success', label: 'fleet.run_state.finished' },
  errored: { tone: 'danger', label: 'fleet.run_state.errored' },
  released: { tone: 'neutral', label: 'fleet.run_state.released' },
  idle: { tone: 'neutral', label: 'fleet.run_state.idle' },
};

export function RunStatePill(props: { state: TaskRunState }): JSX.Element {
  return (
    <StatusPill tone={RUN_STATE_PILL[props.state].tone}>
      {t(RUN_STATE_PILL[props.state].label)}
    </StatusPill>
  );
}
